<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    if (this.$route.query.debug === "show") {
      const VConsole = require("vconsole");
      // eslint-disable-next-line no-new
      new VConsole();
    }
  },
};
</script>
<style lang="less">
html {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  // font-family: 'Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, 微软雅黑, Arial, sans-serif';

  body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    #app {
      width: 100%;
      height: 100%;
      // background: #f7f7f7;
    }
  }
}
</style>
